module.exports = __webpack_public_path__ + "static/media/br.caf2cf2c.svg";